// extracted by mini-css-extract-plugin
export default {"Cropper":"Cropper_Cropper__5CLuG","btn":"Cropper_btn__3h0gr"};